import * as Yup from 'yup';
import moment from 'moment';
import { getRequiredMessage } from 'views/declarations/utils/validation-utils';

export const invoiceDetailsValidationSchema = Yup.object({
    invoiceDetails: Yup.object({
        invoiceNumber: Yup.string().optional().nullable(), //TODO: Make this field required once the invoice number is present
        orderNumber: Yup.string().nullable().required(),
        mrn: Yup.string().nullable().required(),
        jobRefNumber: Yup.string().nullable().required(),
        dueDate: Yup.string()
            .nullable()
            .required(getRequiredMessage('dueDate'))
            .test('not-in-past', 'Due date cannot be in the past', (value) => {
                if (!value) return false;
                const picked = moment(value);
                if (!picked.isValid()) return false;
                return picked.isSameOrAfter(moment().startOf('day'), 'day');
            }),
    }),
    customerDetails: Yup.object({
        name: Yup.string().trim().nullable().required(getRequiredMessage('name')),
        address: Yup.string().trim().nullable().required(getRequiredMessage('address')),
        city: Yup.string().trim().nullable().required(getRequiredMessage('city')),
        postCode: Yup.string().trim().nullable().required(getRequiredMessage('postCode')),
        country: Yup.string().trim().nullable().required(getRequiredMessage('country')),
    }),
});
